// components
import { CopyButton } from '@newo/ui-kit';
// utils
import { cn } from '@/utils';

interface ContentViewerProps {
    className?: string;
    content: string;
    withCounter?: boolean;
}

const ContentViewer = ({
    className,
    content,
    withCounter
}: ContentViewerProps) => {
    return (
        <div
            className={cn(
                'relative px-3 py-8 text-sm font-normal whitespace-pre-wrap rounded-xl bg-gray-1',
                className
            )}
        >
            <div className="absolute inline-flex top-2 right-2 gap-4 items-center py-0.5 px-2 bg-white rounded-lg">
                {withCounter ? (
                    <div className="inline-block p-1 text-xs leading-none">
                        {content.split(' ').length} words
                    </div>
                ) : undefined}

                <CopyButton value={content} />
            </div>
            <div>{content}</div>
        </div>
    );
};

export default ContentViewer;
